import React from 'react';
import moment from 'moment';
import "./available-slots.scss";
import { Typography } from "src/latest/src/components";
import Tooltip from './../../../base/Tooltip/Tooltip'; // custom tooltip element
import { getSlotIcons } from '../../../../utils/helpers';

type Props ={
  availableSlots:Array,
  bookAppointmentSlot:Function,
  isFromMobile:Boolean,
  practiceTimeZone: String,
}


function AvailableSlots({availableSlots,bookAppointmentSlot,isFromMobile=false, practiceTimeZone}:Props) {
    const isClinicianAvailabilityPage = window.location.pathname.includes("/clinician-availability");
    const sortedAvailableSlots = Object.entries(availableSlots);

    // Sort the array by date
    sortedAvailableSlots.sort((a, b) => a[0].localeCompare(b[0]));

    function getTimeToShow(slotStartDateTime: string): string {
        try {
            const dateTime = moment(slotStartDateTime);

            if (!dateTime.isValid()) {
                throw new Error('Invalid date format');
            }

            const formattedTime = (practiceTimeZone && isClinicianAvailabilityPage)
                ? dateTime.tz(practiceTimeZone).format('h:mm A')
                : dateTime.format('h:mm A');

            return formattedTime;
        } catch (error) {
            console.error(error.message);

            return 'Invalid time'; // Default return for error case
        }
    }

  return (
      <div className="slotsContainer ms-2">
          <div className="slotColumn">
              {sortedAvailableSlots?.length > 0 &&
              sortedAvailableSlots[0]?.[1]?.length > 0 &&
              sortedAvailableSlots[0][1] !== undefined ? (
                  sortedAvailableSlots[0][1].map((slot, key) => {
                      return (
                          <Tooltip
                              force={!isFromMobile}
                              text={
                                  <Typography
                                      variant="size-12"
                                      dangerouslySetInnerHTML={{
                                          __html: slot.tool_tip,
                                      }}
                                  />
                              }
                              placement="right"
                              className="ms-1 slot-tooltip"
                              key={key}
                          >
                              <div className="slot" id={key} onClick={()=>bookAppointmentSlot({slot,date:sortedAvailableSlots[0][0]})}>
                                  {getSlotIcons(slot.meeting_pref)}

                                  <Typography
                                      variant="size-12"
                                      color="color-2"
                                      weight="semi-bold"
                                  >
                                      {getTimeToShow(slot.slot_start_date_time)}
                                  </Typography>
                              </div>
                          </Tooltip>
                      );
                  })
              ) : (
                  <div className="no-slot">--</div>
              )}
          </div>
          <div className="slotColumn">
              {sortedAvailableSlots?.length > 0 &&
              sortedAvailableSlots[1]?.[1]?.length > 0 &&
              sortedAvailableSlots[1][1] !== undefined ? (
                  sortedAvailableSlots[1]?.[1]?.map((slot, key) => {
                      return (
                          <Tooltip
                              force={!isFromMobile}

                              text={
                                  <Typography
                                      variant="size-12"
                                      dangerouslySetInnerHTML={{
                                          __html: slot.tool_tip,
                                      }}
                                  />
                              }
                              placement="right"
                              className="ms-1 slot-tooltip"
                              key={key}
                          >
                              <div className="slot" id={key} onClick={()=>bookAppointmentSlot({slot,date:sortedAvailableSlots[1][0]})}>
                                  {getSlotIcons(slot.meeting_pref)}

                                  <Typography
                                      variant="size-12"
                                      color="color-2"
                                      weight="semi-bold"
                                  >
                                      {getTimeToShow(slot.slot_start_date_time)}
                                  </Typography>
                              </div>
                          </Tooltip>
                      );
                  })
              ) : (
                  <div className="no-slot"> --</div>
              )}
          </div>
          <div className="slotColumn">
              {sortedAvailableSlots.length > 0 &&
              sortedAvailableSlots[2]?.[1]?.length > 0 &&
              sortedAvailableSlots[2][1] !== undefined ? (
                  Object.values(sortedAvailableSlots)[2][1].map((slot, key) => {
                      return (
                          <Tooltip
                              force={!isFromMobile}

                              text={
                                  <Typography
                                      variant="size-12"
                                      dangerouslySetInnerHTML={{
                                          __html: slot.tool_tip,
                                      }}
                                  />
                              }
                              placement="right"
                              className="ms-1 slot-tooltip"
                              key={key}
                          >
                              <div
                                  className="slot"
                                  id={key}
                                  onClick={() =>
                                      bookAppointmentSlot({
                                          slot,
                                          date: sortedAvailableSlots[2][0],
                                      })
                                  }
                              >
                                  {getSlotIcons(slot.meeting_pref)}

                                  <Typography
                                      variant="size-12"
                                      color="color-2"
                                      weight="semi-bold"
                                  >
                                      {getTimeToShow(slot.slot_start_date_time)}
                                  </Typography>
                              </div>
                          </Tooltip>
                      );
                  })
              ) : (
                  <div className="no-slot">--</div>
              )}
          </div>
          {!isFromMobile && <div className="slotColumn">
              {sortedAvailableSlots.length > 0 &&
              sortedAvailableSlots[3]?.[1]?.length > 0 &&
              sortedAvailableSlots[3][1] !== undefined ? (
                  sortedAvailableSlots[3][1].map((slot, key) => {
                      return (
                          <Tooltip
                              force={!isFromMobile}
                              text={
                                  <Typography
                                      variant="size-12"
                                      dangerouslySetInnerHTML={{
                                          __html: slot.tool_tip,
                                      }}
                                  />
                              }
                              placement="right"
                              className="ms-1 slot-tooltip"
                              key={key}
                          >
                              <div
                                  className="slot"
                                  id={key}
                                  onClick={() =>
                                      bookAppointmentSlot({
                                          slot,
                                          date: sortedAvailableSlots[3][0],
                                      })
                                  }
                              >
                                  {getSlotIcons(slot.meeting_pref)}

                                  <Typography
                                      variant="size-12"
                                      color="color-2"
                                      weight="semi-bold"
                                  >
                                      {getTimeToShow(slot.slot_start_date_time)}
                                  </Typography>
                              </div>
                          </Tooltip>
                      );
                  })
              ) : (
                  <div className="no-slot">--</div>
              )}
          </div>}
         {!isFromMobile && <div className="slotColumn">
              {sortedAvailableSlots.length > 0 &&
              sortedAvailableSlots[4]?.[1]?.length > 0 &&
              sortedAvailableSlots[4][1] !== undefined ? (
                  sortedAvailableSlots[4][1].map((slot, key) => {
                      return (
                          <Tooltip
                              force={!isFromMobile}
                              text={
                                  <Typography
                                      variant="size-12"
                                      dangerouslySetInnerHTML={{
                                          __html: slot.tool_tip,
                                      }}
                                  />
                              }
                              placement="bottom"
                              className="ms-1 slot-tooltip"
                              key={key}
                          >
                              <div
                                  className="slot"
                                  id={key}
                                  onClick={() =>
                                      bookAppointmentSlot({
                                          slot,
                                          date: sortedAvailableSlots[4][0],
                                      })
                                  }
                              >
                                  {getSlotIcons(slot.meeting_pref)}{" "}
                                  <Typography
                                      variant="size-12"
                                      color="color-2"
                                      weight="semi-bold"
                                  >
                                      {getTimeToShow(slot.slot_start_date_time)}
                                  </Typography>
                              </div>
                          </Tooltip>
                      );
                  })
              ) : (
                  <div className="no-slot">--</div>
              )}
          </div>}
      </div>
  );
}

export default AvailableSlots;

